import {
  REQUEST_SPONSOR_LIST_FOR_MAIN_PAGE,
  REQUEST_SPONSOR_LIST,
  REQUEST_CAMPAIGN_SPONSOR_LIST,
  REQUEST_SPONSOR,
} from './mutation-types';
  
import axiosInst from '@/utility/axiosInst';
  
export default {
  
  requestSponsorListForMainPage({commit}) {
    return axiosInst.springAxiosInst.get("/sponsor/main-page-sponsor-list")
      .then((res) => {
        commit(REQUEST_SPONSOR_LIST_FOR_MAIN_PAGE, res.data)
      })
      .catch(err => {
        console.error('error: ', err)
      })
  },

  requestSponsorList({commit}, payload) {
    const {currentPage, currentCategorySeq} = payload
    return axiosInst.springAxiosInst.get("/sponsor/get-list", {
      params: {
        page: currentPage,
        categorySeq: currentCategorySeq,
      }
    }).then((res) => {
      commit(REQUEST_SPONSOR_LIST, res.data)
    })
  },

  requestSponsor({commit}, sponsorSeq) {
    return axiosInst.springAxiosInst.get("/sponsor/get-detail", {
      params: {
        sponsorSeq: sponsorSeq
      }
    }).then((res) => {
      commit(REQUEST_SPONSOR, res.data)
    })
  },

  requestCampaignSponserListByBetween({commit}, payload) {
    const {currentPage, searchType, startDate, endDate} = payload
    return axiosInst.springAxiosInst.get("/invitation/get-sponser-between-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        startDate: startDate,
        endDate: endDate
      }
    }).then((res) => {
      commit(REQUEST_CAMPAIGN_SPONSOR_LIST, res.data)
    })
  },

  requestCampaignSponserListByDaysAgo({commit}, payload) {
    const {currentPage, searchType, daysAgo} = payload
    return axiosInst.springAxiosInst.get("/invitation/get-sponser-ago-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        daysAgo: daysAgo
      }
    }).then((res) => {
      commit(REQUEST_CAMPAIGN_SPONSOR_LIST, res.data)
    })
  }
}